import { Typography } from "@mui/material";
import type { ContentReportTarget } from "Components/Support/ContentReport/ContentReportTarget";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Support.ContentReport;

/** The persona as the reporter sees it — handle first, since that is the public identity. */
const describeUser = (
  handle: string | null | undefined,
  displayName: string | null | undefined,
) => (handle ? `@${handle}` : (displayName ?? ""));

type Props = {
  target: ContentReportTarget;
};

/** The line above the form that says what the notice is about. */
export const ContentReportTargetDescription = ({ target }: Props) => {
  const { t } = useResource();

  if (target.kind === "profile") {
    return (
      <Typography color="text.secondary">
        {t(RESOURCES.TargetProfile, {
          user: describeUser(target.handle, target.displayName),
        })}
      </Typography>
    );
  }

  if (target.kind === "message") {
    return (
      <Typography color="text.secondary">
        {t(RESOURCES.TargetMessage, {
          user: describeUser(target.authorHandle, target.authorName),
        })}
      </Typography>
    );
  }

  return (
    <Typography color="text.secondary">{t(RESOURCES.MessageHint)}</Typography>
  );
};
